import { useEffect, useRef, useState } from 'react'
import { Box, Typography, TypographyProps, Link } from "@mui/material"
import { BlockCaption } from 'components/controls/blockCaption'

type ClampTypographyProps = {
	caption?: string
	text: string | undefined | null
	clampRow?: number
} & TypographyProps
export const ClampTypography = ({
	caption,
	text,
	clampRow,
	...others
}: ClampTypographyProps) => {
	const [clamp, setClamp] = useState<boolean>(true)
	const [showButton, setShowButton] = useState<boolean>(true)
	const textRef = useRef<HTMLParagraphElement>(null)
	useEffect(
		() => {
				// scrollHeightがclientHeightより大きいかチェック
			const hasClamping = textRef.current ? (
				textRef.current.scrollHeight > textRef.current.clientHeight
			) : false
			setShowButton(hasClamping)
			setClamp(true)
		},
		[text]
	)
	return (
		<Box>
			{(text && caption) && <BlockCaption caption={caption}/>}
			<Box paddingX={caption ? 2 : 0} paddingY={caption ? 1 : 0}>
				<Typography
					ref={textRef}
					variant='body2'
					component='p'
					whiteSpace='pre-wrap'
					translate="yes"
					sx={clamp ? {
						display: '-webkit-box',
						WebkitBoxOrient: 'vertical',
						WebkitLineClamp: clampRow ?? 5,
						overflow: 'hidden'
					} : undefined}
					{...others}
				>
					{text}
				</Typography>
				{showButton && (
					<Link
						underline="hover"
						component="button"
						variant="body2"
						onClick={
							(ev) => {
								ev.stopPropagation()
								setClamp(!clamp)
							}
						}
					>
						{clamp ? "すべて表示" : "閉じる"}
					</Link>
				)}
			</Box>
		</Box>
	)
}
